import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const { language, changeLanguage } = useLanguage();

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const navLinkClass = ({ isActive }) =>
    isActive ? "nav-link active" : "nav-link";

  const text = {
    en: {
      home: "Home",
      cars: "Cars & Prices",
      booking: "Booking",
      contact: "Contact & Socials",
      whatsapp: "WhatsApp",
      book: "Book a Car",
    },

    sq: {
      home: "Kryefaqja",
      cars: "Makinat & Çmimet",
      booking: "Rezervimi",
      contact: "Kontakt & Rrjetet Sociale",
      whatsapp: "WhatsApp",
      book: "Rezervo Makinë",
    },
  };

  const t = text[language];

  return (
    <>
      <header className="navbar">
        <div className="navbar-inner">
          <Link
            to="/"
            className="brand"
            onClick={closeMenu}
          >
            <div className="brand-logo">AR</div>

            <div>
              <div className="brand-title">
                AutoRent Albania
              </div>

              <div className="brand-subtitle">
                Drive Albania your way
              </div>
            </div>
          </Link>

          <nav className="desktop-nav">
            <NavLink
              to="/"
              end
              className={navLinkClass}
            >
              {t.home}
            </NavLink>

            <NavLink
              to="/cars"
              className={navLinkClass}
            >
              {t.cars}
            </NavLink>

            <NavLink
              to="/booking"
              className={navLinkClass}
            >
              {t.booking}
            </NavLink>

            <NavLink
              to="/contact"
              className={navLinkClass}
            >
              {t.contact}
            </NavLink>
          </nav>

          <div className="desktop-actions">
            {/* LANGUAGE SWITCHER */}

            <div className="language-switcher">
              <button
                type="button"
                className={
                  language === "en"
                    ? "language-button active"
                    : "language-button"
                }
                onClick={() =>
                  changeLanguage("en")
                }
              >
                EN
              </button>

              <span className="language-divider">
                |
              </span>

              <button
                type="button"
                className={
                  language === "sq"
                    ? "language-button active"
                    : "language-button"
                }
                onClick={() =>
                  changeLanguage("sq")
                }
              >
                SQ
              </button>
            </div>

            <a
              href="https://wa.me/355697555461"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-whatsapp"
            >
              {t.whatsapp}
            </a>

            <Link
              to="/booking"
              className="navbar-book-button"
            >
              {t.book}
            </Link>
          </div>

          <button
            type="button"
            className="menu-button"
            onClick={() =>
              setMenuOpen((current) => !current)
            }
            aria-label="Open navigation menu"
          >
            {menuOpen ? (
              <svg
                viewBox="0 0 24 24"
                width="26"
                height="26"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M6 6L18 18"
                  strokeLinecap="round"
                />

                <path
                  d="M18 6L6 18"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <svg
                viewBox="0 0 24 24"
                width="26"
                height="26"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M4 7H20"
                  strokeLinecap="round"
                />

                <path
                  d="M4 12H20"
                  strokeLinecap="round"
                />

                <path
                  d="M4 17H20"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </button>
        </div>
      </header>

      {menuOpen && (
        <div className="mobile-menu">
          {/* MOBILE LANGUAGE SWITCHER */}

          <div className="mobile-language-section">
            <span className="mobile-language-label">
              Language / Gjuha
            </span>

            <div className="mobile-language-buttons">
              <button
                type="button"
                className={
                  language === "en"
                    ? "mobile-language-button active"
                    : "mobile-language-button"
                }
                onClick={() =>
                  changeLanguage("en")
                }
              >
                English
              </button>

              <button
                type="button"
                className={
                  language === "sq"
                    ? "mobile-language-button active"
                    : "mobile-language-button"
                }
                onClick={() =>
                  changeLanguage("sq")
                }
              >
                Shqip
              </button>
            </div>
          </div>

          <nav className="mobile-nav">
            <NavLink
              to="/"
              end
              className={navLinkClass}
              onClick={closeMenu}
            >
              {t.home}
            </NavLink>

            <NavLink
              to="/cars"
              className={navLinkClass}
              onClick={closeMenu}
            >
              {t.cars}
            </NavLink>

            <NavLink
              to="/booking"
              className={navLinkClass}
              onClick={closeMenu}
            >
              {t.booking}
            </NavLink>

            <NavLink
              to="/contact"
              className={navLinkClass}
              onClick={closeMenu}
            >
              {t.contact}
            </NavLink>
          </nav>

          <div className="mobile-actions">
            <a
              href="https://wa.me/355697555461"
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-whatsapp"
            >
              {t.whatsapp}
            </a>

            <Link
              to="/booking"
              className="mobile-book-button"
              onClick={closeMenu}
            >
              {t.book}
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;